import type { FunctionComponent } from 'react';
import { Markdown } from '../../../../components/markdown';
import type { BentoPieceRectangleFourPartsFragment } from '../../../../graphql/queries/GetBentoOne.graphql';
import { usePersonalizations } from '../../../../lib/hooks/usePersonalizations';
import { renderTemplate } from '../../../../lib/utils/text';
import styles from './bento-rectangle-four-parts.module.scss';
export const Part: FunctionComponent<Props> = ({
  copy
}) => {
  const personalizations = usePersonalizations();
  return <div className={styles.copy} data-sentry-component="Part" data-sentry-source-file="part.tsx">
            <Markdown tag='h3' typeStyle='heading-xs' markdown={renderTemplate(copy, personalizations)} data-sentry-element="Markdown" data-sentry-source-file="part.tsx" />
        </div>;
};
export default Part;
type Props = Omit<BentoPieceRectangleFourPartsFragment, 'sys' | 'type'> & {
  copy?: string;
};